export default `
uniform vec4 color;
uniform float diffusePower;
uniform float alphaPower;
uniform float globalAlpha;
uniform vec2 center;
uniform bool isInner;

czm_material czm_getMaterial(czm_materialInput materialInput) {
  czm_material material = czm_getDefaultMaterial(materialInput);
  vec2 st = materialInput.st;
  float alphaMars3D = distance(st, center);
  if(isInner) {
    material.alpha = (1.0 - (color.a * alphaMars3D * alphaPower)) * globalAlpha;
  } else {
    material.alpha = color.a * alphaMars3D * alphaPower * globalAlpha;
  }

  if(st.s>center.x){
    material.alpha=0.0;
  }

  material.diffuse = color.rgb * diffusePower;
  return material;
}

`;